<div id="printContainer" #printContainer style="visibility: hidden;">
  <header class="baer-header">
    @if (report?.assessment) {
    <div class="breadcrumb"><a routerLink="/assessments">BAER Assessments</a> &gt; <a [routerLink]="'/fire-overview'"
        [queryParams]="{assessment_id: report?.assessment?.assessment_id}">{{report?.assessment?.baer_name}}</a>
      &gt; {{ report?.baer_name }} ({{report?.report_num}})</div>
    }
    @if (report) {
    <h1 id="table" class="site-page-title"><span class="large-font">{{report.baer_name}}
        ({{report.report_num}})</span></h1>
    }
    @if (report) {
    <div class="status-div">
      Report ID: {{ report.report_id }} <span class="spacer">|</span>Action: {{ "Initial" }}
    </div>
    }
    @if (report) {
    <div class="status-div">
      Report Status:
      <mat-chip [ngClass]="'chip-r-'+report?.report_status_id">
        {{report.report_status_id | reportStatusBadge}}
      </mat-chip>
      @if (report.report_status_id == 2) {
      <span class="spacer">|</span>Authorization Status:
      <mat-chip [ngClass]="'chip-a-'+report?.authorization_status_id">
        {{report.authorization_status_id | authorizationStatusBadge}}
      </mat-chip>
      }
    </div>
    }
  </header>
  <div class="report-main">
    <div class="report-right-area">
      <div class="report-area">
        <div class="report-area">
          @if (report) {
          <div class="report-section">
            <app-funding-print id="wo-funding" [report]="report" [updateReportSubject]="updateReportSubject"
              [readySubject]="readyStatus" [requiresWOFunding]="requiresWOFunding"></app-funding-print>
            <app-view-ro-signatures id="regional-signatures" [report]="report"></app-view-ro-signatures>
            @if(requiresWOFunding) {
            <app-view-wo-signatures id="wo-signatures" [report]="report"></app-view-wo-signatures>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>